module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_8019.68defe8b.png";